import { Api } from '../utils';

const LoginActions = {

  async onLogin(userData) {
    const url = `TokenAuth/Authenticate`;
    try {
      const response = await Api.fetchAsync(url, 'POST', userData, null, false);
      Api.validateResponse(response, url);
      return ((await response.json()).result);
    } catch(e) {
      return null;
    }
  },


  async getIfTokenIsValid() {
    const url = 'services/app/Session/IsValidToken';
    try {
      const response = await Api.fetchAsync(url, 'POST');
      Api.validateResponse(response, url);
      return (( await response.json()).result);
    } catch(e) {
      return false;
    }
  },
  async createSubscription(data) {
    const url = 'services/app/Subscription/Create';
    try {
      const response = await Api.fetchAsync(url, 'POST', data);
      Api.validateResponse(response, url);
      return ((await response.json()).result);
    } catch (e) {
      return false;
    }
  },
  async existSubscription(data) {
    const url = 'services/app/Subscription//ExistSubscription';
    try {
      const response = await Api.fetchAsync(url, 'POST', data);
      Api.validateResponse(response, url);
      return ((await response.json()).result);
    } catch (e) {
      return false;
    } 
  }

};

export default LoginActions;